export default "__VITE_ASSET__DhRYOaq5__"